/* Native OR length selections; other specifications keep their collection tag scope. */
if (!window.pdrHandToolsLinksBound) {
  window.pdrHandToolsLinksBound = true;
  window.pdrHandToolsTarget = (anchor, currentHref) => {
    const current = new URL(currentHref);
    const target = new URL(anchor.href, current);
    const params = new URLSearchParams(current.search);
    ['page', 'section_id', 'sections'].forEach(key => params.delete(key));
    if (anchor.hasAttribute('data-ht-reset')) {
      for (const key of [...params.keys()]) if (key.startsWith('filter.')) params.delete(key);
    } else if (anchor.hasAttribute('data-ht-native-length')) {
      const values = new Set(params.getAll('filter.p.tag').flatMap(value => value.split(',')).filter(Boolean));
      // Migrate existing bookmarked single-length tag URLs to the native filter.
      const base = new URL(anchor.dataset.htBase, current).pathname;
      const oldTags = current.pathname.slice(base.length + 1).split('+').filter(Boolean);
      for (const tag of oldTags) if (tag.startsWith('ht-length-')) values.add(tag);
      target.pathname = base + (oldTags.filter(tag => !tag.startsWith('ht-length-')).length ? '/' + oldTags.filter(tag => !tag.startsWith('ht-length-')).join('+') : '');
      const tag = anchor.dataset.htTag;
      const removeTag = anchor.dataset.htRemoveTag;
      if (removeTag) values.delete(removeTag);
      else if (!tag) { for (const value of values) if (value.startsWith('ht-length-')) values.delete(value); }
      else if (values.has(tag)) values.delete(tag);
      else values.add(tag);
      params.delete('filter.p.tag');
      for (const value of values) params.append('filter.p.tag', value);
    }
    if (!anchor.hasAttribute('data-ht-native-length')) {
      const base = new URL(anchor.dataset.htBase || target.pathname, current).pathname;
      const prefix = anchor.dataset.htPrefix;
      let tags = current.pathname.slice(base.length).replace(/^\//, '').split('+').filter(Boolean);
      if (anchor.hasAttribute('data-ht-reset')) tags = [];
      else if (prefix) {
        tags = tags.filter(tag => !tag.startsWith(prefix));
        if (anchor.dataset.htTag) tags.push(anchor.dataset.htTag);
      }
      target.pathname = base + (tags.length ? '/' + tags.join('+') : '');
    }
    target.search = params.toString();
    return target.href;
  };
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('[data-ht-link], [data-ht-reset]');
    if (!anchor) return;
    anchor.href = window.pdrHandToolsTarget(anchor, window.location.href);
  });
}

/* Mobile custom filters are staged until Apply; native price/sort share that URL. */
if (!window.pdrMobileFiltersBound) {
  window.pdrMobileFiltersBound = true;
  const pending = new WeakMap();
  const sync = (form, href) => {
    const url = new URL(href);
    const base = new URL(form.dataset.pdrBase, url).pathname;
    const tags = url.pathname.slice(base.length).replace(/^\//, '').split('+').filter(Boolean);
    const lengths = url.searchParams.getAll('filter.p.tag').flatMap(v => v.split(','));
    form.querySelectorAll('[data-pdr-mobile-options] [data-ht-link]').forEach(a => {
      const prefix = a.dataset.htPrefix;
      const values = a.hasAttribute('data-ht-native-length') ? lengths : tags;
      const active = a.dataset.htTag ? values.includes(a.dataset.htTag) : !values.some(v => v.startsWith(prefix));
      a.classList.toggle('is-active', active);
      if (active) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  };
  document.addEventListener('click', event => {
    const open = event.target.closest('.mobile-facets__open-wrapper');
    if (open) {
      const form = open.closest('.mobile-facets__disclosure').querySelector('[data-pdr-mobile-form]');
      if (form) { form.reset(); pending.set(form, window.location.href); sync(form, window.location.href); }
    }
    const form = event.target.closest('[data-pdr-mobile-form]');
    if (!form) return;
    const link = event.target.closest('[data-pdr-mobile-options] [data-ht-link]');
    const apply = event.target.closest('[data-pdr-mobile-apply]');
    const clear = event.target.closest('[data-pdr-mobile-clear]');
    if (!link && !apply && !clear) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (clear) {
      const url = new URL(form.dataset.pdrBase, window.location.href);
      const current = new URL(window.location.href);
      for (const key of ['preview_theme_id', 'sort_by']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      window.location.assign(url.href);
    } else if (link) {
      const next = window.pdrHandToolsTarget(link, pending.get(form) || window.location.href);
      pending.set(form, next); sync(form, next);
    } else {
      const url = new URL(pending.get(form) || window.location.href);
      for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.') && key !== 'filter.p.tag') url.searchParams.delete(key);
      for (const [key, value] of new FormData(form)) {
        if (key === 'filter.p.tag') continue;
        if (key.startsWith('filter.') || key === 'sort_by') {
          if (value !== '') url.searchParams.append(key, value);
        }
      }
      const sort = new FormData(form).get('sort_by');
      if (sort) url.searchParams.set('sort_by', sort);
      ['page', 'section_id', 'sections'].forEach(key => url.searchParams.delete(key));
      window.location.assign(url.href);
    }
  }, true);
}
